export default function(size: number, unit: 'kb' | 'mb'): string {
    switch (unit) {
        case 'kb': {
            return `${Math.floor(size / Math.pow(2, 10))} KB`;
        }
        case 'mb': {
            return `${Math.floor(size / Math.pow(2, 20))} MB`;
        }
    }
}
